module.exports = __webpack_public_path__ + "static/img/stagepostion.78d2993.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/stagepostion.png
// module id = bhSh
// module chunks = 44